import { StyleguideCompanyType, StyleguidePages, StyleguideProjectInfoType } from "../utils/types";

// ADD PROJECT CONFIGURATION HERE
export const styleguideProject: StyleguideProjectInfoType = {
  name: 'evofenedex',
  logoSrc: '/images/logo--white.png'
}

export const styleguideBreakpoint: number = 768
export const styleguideCompany: StyleguideCompanyType = 'hoppinger'

// CUSTOMIZE STYLEGUIDE HOMEPAGE HERE
export const styleguideDefaultSlug: StyleguidePages = 'tokens'

// CUSTOMIZE PLACEHOLDER IMAGE HERE
export const styleguidePlaceholderText = {
  font: 'Open Sans, sans-serif',
  color: '#535054'
}

export const styleguidePlaceholderShape = {
  bgColor: '#F4FAFA'
}
